/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2020-02-10 14:55:35
 * @modify date 2020-02-10 14:55:35
 * @desc [description]
 */
import axios from 'axios';

export async function getServiceProviderFiltersData() {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/lab_filters`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get service providers filters data', err); // eslint-disable-line no-console
    });
  return result;
}

export async function getDataBasedOnSelectedFilter(payload) {
  let result = [];
  await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/resources/pick_filter_data`, payload)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get data based on selected filter', err); // eslint-disable-line no-console
    });
  return result;
}

export async function getServiceProviderFilteredData(productId, activityAreaId, testAndNormId) {
  let result = [];
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/lab_filters_data?product=${productId}&activity_area=${activityAreaId}&test_and_norm=${testAndNormId}`)
    .then((response) => {
      if (response.status === 200) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get service providers filtered data', err); // eslint-disable-line no-console
    });
  return result;
}

export async function getFilteredData(start, end, searchType, searchValue) {
  let filteredData = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/resources/service_provider?page=${start}&pageSize=${end}&searchType=${searchType}&searchValue=${searchValue}`)
    .then((response) => {
      filteredData = response.data.data;
    })
    .catch((err) => {
      console.log('filteredData get java api error', err); // eslint-disable-line no-console
    });
  return filteredData;
}
export async function getLabsData(searchValue) {
  let filteredData = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/resources/service_provider_labs?searchValue=${searchValue}`)
    .then((response) => {
      filteredData = response.data;
    })
    .catch((err) => {
      console.log('filteredData get java api error', err); // eslint-disable-line no-console
    });
  return filteredData;
}

export async function getContactDetails(data) {
  let filteredData = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/resources/contact_details?testId=${data}`)
    .then((response) => {
      filteredData = response.data;
    })
    .catch((err) => {
      console.log('filteredData get java api error', err); // eslint-disable-line no-console
    });
  return filteredData;
}

/**
 * representation/resources get API
* to get the representation resources based on country */
export async function getRepresentationResourcesByCountry(country) {
  let resources = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/representation/resources/${country}`)
    .then((response) => {
      resources = response.data.data;
    })
    .catch((err) => {
      console.log('representation/resources get java api error', err); // eslint-disable-line no-console
    });
  return resources;
}

/**
 * representation/resources/countries get API
* to get the representation resources countrieslist */
export async function getRepresentationCountriesList() {
  let countriesList = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/representation/resources/countries`)
    .then((response) => {
      countriesList = response.data.data;
    })
    .catch((err) => {
      console.log('/representation/resources/countries java api error', err); // eslint-disable-line no-console
    });
  return countriesList;
}

/**
 * representation/resources post API
* to add new representation resource */
export async function addDocumentByCountry(formData) {
  let result = false;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/representation/resources`, formData)
    .then((response) => {
      if (response
        && response.data.status_code === 200
        && response.data.message === 'success') {
        result = true;
      }
    })
    .catch((err) => {
      console.log('/representation/resources post java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * representation/resources put API
* to update the representation resource */
export async function editDocumentByCountry(formData) {
  let result = false;
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/representation/resources`, formData)
    .then((response) => {
      if (response
        && response.data.status_code === 200
        && response.data.message === 'success') {
        result = true;
      }
    })
    .catch((err) => {
      console.log('/representation/resources put java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * representation/resources delete API
* to delete the representation resources */
export async function deleteResourceById(id) {
  let delTableData = false;
  await axios
    .delete(`${process.env.VUE_APP_JAVA_API_URL}/representation/resources/${id}`)
    .then((response) => {
      if (response
        && response.data.status_code === 200
        && response.data.message === 'success') {
        delTableData = true;
      }
    })
    .catch((err) => {
      console.log('/representation/resources delete java api error', err); // eslint-disable-line no-console
    });
  return delTableData;
}

/**
 * representation/resources/add/countries post API
* to add new countires to representation resources */
export async function addNewResourceCountry(data) {
  let addedCountry = false;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/representation/resources/add/countries`, data)
    .then((response) => {
      if (response
        && response.data.status_code === 200
        && response.data.message === 'success') {
        addedCountry = true;
      }
    })
    .catch((err) => {
      console.log('/representation/resources/add/countries java api error', err); // eslint-disable-line no-console
    });
  return addedCountry;
}

export async function getCategoriesList() {
  let categoriesList = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/representation/resources/category`)
    .then((response) => {
      categoriesList = response.data.data;
    })
    .catch((err) => {
      console.log('the categories list error is', err); // eslint-disable-line no-console
    });
  return categoriesList;
}
